import useHopperPrice from "@/hooks/useHopper"
import { Stack, Typography } from "@mui/material"
import React from "react"
import { TokenAvatar } from "../TokenAvatar"

export default function TokenDisplay({
  token,
}: {
  token: { denomination: number; id: string; logo: string; name: string; ticker: string }
}) {
  const tokenPrice = useHopperPrice(token.id, "usd")

  return (
    <Stack>
      <Stack direction="row" spacing={0.5} alignItems="center">
        <TokenAvatar tokenId={token.id} />
        <Typography variant="inherit" fontWeight={500}>
          {token.ticker}
        </Typography>

        {tokenPrice.data ? (
          <Typography
            variant="inherit"
            color="text.secondary"
            sx={{
              animation:
                tokenPrice.isLoading || tokenPrice.isFetching ? "pulse 1.5s infinite" : "none",
            }}
          >
            ${tokenPrice.data.toFixed(2)}
          </Typography>
        ) : null}
      </Stack>
      {/*      <Typography variant="caption" color="text.secondary">
          {truncateId(token.id)}
        </Typography> */}
    </Stack>
  )
}
